export default "__VITE_ASSET__CEQmlo3U__"